import { Container } from 'react-bootstrap';
import { BsPlusCircle } from "react-icons/bs";
import { BsDashCircle } from "react-icons/bs";

export const CartBuy = ({ cartItems, newAddProduct, minProduct }) => {
  const totalPrice = cartItems && cartItems.length > 0 ? cartItems.reduce((price, item) => price + item.quantity * item.price, 0) : 0;
  const totalProducts = cartItems && cartItems.length > 0 ? cartItems.reduce((quantity, item) => quantity + item.quantity, 0) : 0;
  return (
    <div>
      {cartItems && cartItems.length === 0 && (
        <div>Su carrito esta vacío</div>
      )}
      <Container className='products-cart'>
        {cartItems.map((item) => (
          <div key={item.id} class="card-cart mb-3" style={{ width: 540 }} >
            <div class="row g-0">
              <div className="col-md-4">
                <img src={item.img} className="img-fluid " alt={item.name} />
              </div>
              <div class="col-md-8">
                <div class="card-body">
                  <h6 class="card-title"> {item.name} </h6>
                  <p class="card-text"> $ {item.price} </p>
                  <p class="card-text"><small class="text-body-secondary">Precio incluye iva</small></p>
                </div>
                <div className='btn-cart-op'>
                  <BsPlusCircle className='btn-cart-add' onClick={() => newAddProduct(item)} />
                  {item.quantity}
                  <BsDashCircle className='btn-cart-min' onClick={() => minProduct(item)} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </Container>
      <Container>
        <br />
        <div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Cantidad</th>
                <th scope="col">Descripción</th>
                <th scope="col">Precio unitario</th>
              </tr>
            </thead>
            <tbody class="table-group-divider">
              {cartItems.map((item) => (
                <tr>
                  <th scope="row">
                    {item.quantity}
                  </th>
                  <td className='table-name'> {item.name} </td>
                  <td> {item.price}  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td>  {totalProducts}  </td>
                <td className='totalPagar'>Total a pagar</td>
                <td> $ {totalPrice} </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </Container>
      <button className='btn-pay'>Continuar compra</button>
    </div>
  )
}